import { makeExportAction } from "src/actions/makeExportAction"

export const ExportAction = ({ onExport }) =>
  makeExportAction({ noun: "reservation", onExport })

export const SendMessageAction = ({ onClickSingle, onClickBulk }) => ({
  label: "Send Message",
  icon: "md-mail",
  onClickSingle,
  onClickBulk,
})
